// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4804":"d72d7184237c77d0","5659":"705ccc7efc9d7b8f"}[chunkId] + ".css";
};